import { NodeProps } from "reactflow";
import NodeCard from "../NodeCard";
import { FlowModuleItemType } from "@packages/flow-core/module";
import { Divider } from "antd";
import RenderInput from "../render/RenderInput";
import RenderOutput from "../render/RenderOutput";
import styles from "./index.less";
import { memo } from "react";

export default memo(function NodeAnswer({
  data,
  selected,
}: NodeProps<FlowModuleItemType>) {
  const { moduleId, inputs, outputs } = data;

  return (
    <NodeCard minWidth={400} selected={selected} {...data}>
      <Divider style={{ margin: 0 }} />
      <div className={styles.content}>
        <RenderInput moduleId={moduleId} flowInputList={inputs} />
        <RenderOutput moduleId={moduleId} flowOutputList={outputs} />
      </div>
    </NodeCard>
  );
});
